// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"textFrame__gradient-bg5__Rn17K","title":"textFrame__title__j0yXA","description":"textFrame__description__gzou7"};